export const MAIN_CAT_ACTION = 'MAIN_CAT_ACTION';
export const MAIN_CAT_SUCCESS_ACTION = 'MAIN_CAT_SUCCESS_ACTION';
export const MAIN_CAT_FAILURE_ACTION = 'MAIN_CAT_FAILURE_ACTION';
